import React, { Component } from 'react'
import AppButton from './AppButton'
import {
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownItem,
    CSpinner
} from '@coreui/react'
import CIcon from '@coreui/icons-react'

export default class TableActions extends Component {

    constructor(props) {
        super(props)

        let activeMenus = this.getActiveMenus(props.actions);

        var firstSet = [];
        var secondSet = [];
        if (props.minCount && props.minCount < activeMenus.length) {

            for (var i = 0; i < activeMenus.length; i++) {

                if (i <= props.minCount - 2) {

                    firstSet[firstSet.length] = activeMenus[i];
                }
                else {

                    secondSet[secondSet.length] = activeMenus[i];
                }
            }
        }
        else {

            firstSet = activeMenus;
        }

        this.state = {
            firstSet: firstSet,
            secondSet: secondSet
        }
    }

    getActiveMenus(menuList) {

        var activeList = [];
        for (var i = 0; i < menuList.length; i++) {

            if (menuList[i].visible) {

                activeList[activeList.length] = menuList[i];
            }
        }

        return activeList;
    }

    render() {

        return (
            <div>
                {
                    this.state.firstSet.length > 0 ?
                        this.state.firstSet.map((object, index) => {
                            return <AppButton
                                name={object.name}
                                icon={object.icon}
                                isLoading={object.isLoading}
                                size="xs"
                                key={String(index)}
                                onClick={() => object.onClick ? object.onClick(object.data) : null}
                                className="tableActionButton" />;
                        })
                        : null
                }
                {
                    this.state.secondSet.length > 0 ?
                        <CDropdown>
                            <CDropdownToggle color="dark" size="xs">Actions</CDropdownToggle>
                            <CDropdownMenu>
                                {
                                    this.state.secondSet.map((object, index) => {
                                        return (
                                            <CDropdownItem
                                                href="#"
                                                key={String(index)}
                                                className="tableActionDropDown"
                                                onClick={() => object.onClick ? object.onClick(object.data) : null}>
                                                {
                                                    object.isLoading ?
                                                        <CSpinner color="light" size="sm" component="span" className="btnSpinner" />
                                                        :
                                                        object.icon ?
                                                            <CIcon icon={object.icon} />
                                                            : null
                                                }
                                                {object.name}
                                            </CDropdownItem>
                                        );
                                    })
                                }
                            </CDropdownMenu>
                        </CDropdown>
                        : null
                }
            </div>
        )
    }
}
